import React from "react";
import "./skills.css";
import { techStack } from "../../data";
import { Fade } from "react-reveal";
import styled from "styled-components";

function StackProgress() {
  if (techStack.viewSkillBars) {
    return (
      <Container>
        <Fade duration={1000} top>
          <Title>
            <h1>Skills</h1>
          </Title>
        </Fade>
        <Fade bottom duration={1000} distance="20px">
          <div className="skills-container">
            <div className="skills-bar">
              {techStack.experience.map((exp, i) => {
                const progressStyle = {
                  width: exp.progressPercentage,
                };
                return (
                  <div key={i} className="skill">
                    <p>{exp.Stack}</p>
                    <div className="meter">
                      <span style={progressStyle}></span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Fade>
      </Container>
    );
  }
  return null;
}

export default StackProgress;

const Container = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`;
const Title = styled.div`
  font-size: 22px;
`;
